<script setup lang="ts">
definePageMeta({
  static: true,
  title: 'Termos de Uso da Plataforma'
})

const breadcrumbData = [{
  title: 'Home',
  link: '/',
  subitems: [
    {title: 'Termos de Uso da Plataforma'}
  ]
}]
</script>
<template>
  <div class="container pb-lg-4 mb-sm-2">
    <Breadcrumb :data="breadcrumbData"/>
    <div class="row">
      <PoliticsMenu activePage="use-terms"/>

      <div class="col-lg-8 col-md-7 mb-5">
        <h1 class="mb-4 pb-lg-2 h2">Termos de Uso</h1>
        <h4 class="h4"><b>1. Objeto</b></h4>
        <p>Estes Termos regulam o uso da plataforma {{ socialInfo.fantasyName }}, operada por {{
            socialInfo.fantasyName
          }} (CNPJ nº {{ socialInfo.cnpj }}), que atua como intermediadora na venda de
          ingressos on-line, disponibilizados pelos organizadores de eventos.</p>
        <p>Ao utilizar nossos serviços, o consumidor declara que leu, compreendeu e aceitou integralmente este
          Termo.</p>
        <h4 class="h4"><b>2. Natureza do Serviço</b></h4>
        <ul>
          <li>A {{ socialInfo.fantasyName }} não organiza eventos. Sua responsabilidade se limita à intermediação de
            pagamentos e emissão
            de ingressos digitais ou vouchers.
          </li>
          <li>Todas as informações, atrações, horários, alterações e cancelamentos são de responsabilidade exclusiva
            do organizador do evento.
          </li>
          <li>Reclamações ou demandas judiciais relacionadas ao evento devem ser direcionadas ao organizador,
            devidamente identificado no ingresso.
          </li>
        </ul>
        <h4 class="h4"><b>3. Taxa de Serviço e Remuneração</b></h4>
        <ul>
          <li>O uso da plataforma pode gerar a cobrança de uma taxa de serviço, prevista em lei (Lei Federal nº
            11.771/2008).
          </li>
          <li>Essa taxa é sempre informada de forma destacada ao consumidor, separadamente do valor do ingresso.</li>
          <li>Caso o consumidor não queira pagar a taxa, poderá adquirir ingressos diretamente na bilheteria ou pontos
            de venda divulgados pelo organizador.
          </li>
        </ul>
        <h4 class="h4"><b>4. Procedimento de Compra</b></h4>
        <ul>
          <li>O consumidor deve se cadastrar com informações verdadeiras, mantendo login e senha em sigilo.</li>
          <li>O pagamento pode ser feito via cartão de crédito ou boleto, conforme disponibilidade.</li>
          <li>Compras podem ser canceladas pela plataforma em caso de fraude, uso de dados de terceiros ou
            inconsistências de segurança.
          </li>
          <li>O ingresso digital é pessoal e intransferível, devendo ser apresentado com documento oficial de
            identificação.
          </li>
          <li>A retirada de ingressos por terceiros exige procuração específica e documentos comprobatórios.</li>
        </ul>
        <h4 class="h4"><b>5. Cancelamento e Reembolso</b></h4>
        <ul>
          <li>Caso a compra tenha sido realizada a menos de 7 dias da data do evento, o cancelamento deverá ser solicitado com, no mínimo, <b>48 horas de antecedência do evento</b>.</li>
          <li>Nos cancelamentos solicitados pelo consumidor, dentro dos prazos e condições acima, será reembolsado o <b>valor correspondente ao(s) ingresso(s). A taxa de serviço/administrativa da plataforma não será reembolsada</b>, por corresponder aos serviços de intermediação, processamento e disponibilização da plataforma.</li>
          <li>O reembolso será realizado, sempre que possível, pelo <b>mesmo meio de pagamento utilizado na compra. Quando necessária a devolução via PIX ou transferência bancária, os dados informados deverão pertencer ao titular da compra</b>.</li>
          <li>Em caso de <b>cancelamento do evento pelo organizador</b>, serão observadas as regras legais aplicáveis quanto à restituição dos valores pagos.</li>
          <li>Solicitações realizadas após os prazos previstos acima deverão ser tratadas diretamente com o <b>organizador do evento</b>.</li>
        </ul>
        <h4 class="h4"><b>6. Responsabilidades</b></h4>
        <ul>
          <li>{{ socialInfo.fantasyName }} responde apenas pelos serviços de intermediação e emissão de ingressos,
            conforme previsto no
            <b>Marco Civil da Internet (Lei nº 12.965/2014).</b></li>
          <li>O <b>organizador</b> é o único responsável pelo evento, incluindo: atrações, qualidade do serviço,
            cumprimento da meia-entrada, cancelamentos, adiamentos e informações divulgadas.
          </li>
          <li>A {{ socialInfo.fantasyName }} pode suspender cadastros e encaminhar dados às autoridades em casos de
            fraude, uso indevido
            ou descumprimento deste Termo.
          </li>
        </ul>
        <h4 class="h4"><b>7. Condições Gerais</b></h4>
        <ul>
          <li>Estes Termos podem ser atualizados a qualquer momento, sem necessidade de aviso prévio.</li>
          <li>A nulidade de uma cláusula não invalida o restante do contrato.</li>
          <li>Fica eleito o <b>foro da Comarca da Capital, Estado de Santa Catarina</b>, para dirimir eventuais
            conflitos, com renúncia a qualquer outro foro.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  text-align: justify;
  opacity: 70;
  font-size: 14px;
}
</style>
